<template>
    <toolbar-option>
        <template slot="primary">
            <toggle v-model="isEnabled" />

            <div v-show="isEnabled" class="option__multi">
                <span class="option__multi-label">
                    Mobile Breakpoint

                    <tooltip>
                        The mobile version of the nav will activate below the selected breakpoint.
                    </tooltip>
                </span>

                <div class="option__input">
                    <dropdown
                        :value="breakpoint"
                        :options="breakpointOptions"
                        @input="onBreakpointSelect"
                    />
                </div>
            </div>
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';
import tailwindScreens from '@/../tailwind.screens';

const CUSTOM_ATTR_NAME = 'advanced-nav-breakpoint';

export default {
    name: 'advanced-nav-breakpoint',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Enable',
            breakpoint: '',
            breakpointOptions: Object.values(tailwindScreens)
                .filter(opt => opt.min)
                .reverse()
                .map((opt) => {
                    return {
                        text: opt.min,
                        value: Number(opt.min.slice(0, -2)),
                    };
                }),

            isEnabled: false,
        };
    },

    watch: {
        isEnabled() {
            if (!this.isEnabled) {
                this.selectedElements[0].removeElementData(CUSTOM_ATTR_NAME);
            }
        },
    },

    methods: {
        onBreakpointSelect(breakpoint) {
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, breakpoint);
            this.breakpoint = breakpoint;
        },

        onSelectedElement() {
            const breakpoint = this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME);

            if (breakpoint) {
                this.isEnabled = true;
                this.breakpoint = breakpoint;
            }
        },
    },
};
</script>
